import { ErrorMessage, useField } from 'formik'
import { type FC } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import styles from '../FormSelect/FormSelect.module.scss'

interface CaptchaProps {
  name: string;
}

const TOKEN = process.env.NEXT_PUBLIC_GOOGLE_CAPTCHA_TOKEN ?? ''

export const Captcha: FC<CaptchaProps> = ({ name }): JSX.Element => {
  const [, , helpers] = useField(name)
  const captchaChange = (value: string | null): void => {
    helpers.setValue(value)
      .catch(console.error)
  }

  if (!TOKEN) {
    return (
      <div>
        <p>Missing captcha token</p>
      </div>
    )
  }

  return (
    <div>
      <ReCAPTCHA
        sitekey={TOKEN}
        onChange={captchaChange}
      />
      <ErrorMessage
        className={styles['form-input__error-message']}
        component="div"
        name={name}
      />
    </div>
  )
}
